module.exports = __webpack_public_path__ + "assets/img/DS-room2 (3).789b3097.jpg";